import React, { useEffect, useState } from "react";
import API from "../services/api";
/* ----------------------------------------------------
   FINAL FIXED BASE URL
----------------------------------------------------- */
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AdminOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  /* -----------------------------------------
     FETCH ORDERS (FULLY FIXED)
  ------------------------------------------- */
  const fetchOrders = async () => {
    try {
      const res = await API.get("/orders");
      const data = res.data;

      // FIX 1 → use data.orders (NOT data)
      setOrders(data.orders || []);
    } catch (err) {
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  /* -----------------------------------------
     DELETE ORDER
  ------------------------------------------- */
  const handleDelete = async (orderId) => {
    if (!window.confirm("Delete this order?")) return;

    try {
      const res = await fetch(`${API_BASE_URL}/orders/${orderId}`, {
        method: "DELETE",
      });

      if (res.ok) {
        alert("Order deleted.");
        fetchOrders();
      } else {
        alert("Delete failed.");
      }
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  /* -----------------------------------------
     GROUP BY DATE
  ------------------------------------------- */
  const grouped = orders.reduce((acc, order) => {
    const date = new Date(order.createdAt).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    if (!acc[date]) acc[date] = [];
    acc[date].push(order);
    return acc;
  }, {});

  if (loading) {
    return <div style={{ padding: "2rem", fontSize: "18px" }}>Loading…</div>;
  }

  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "0 auto" }}>
      <h1
        style={{
          fontSize: "28px",
          fontWeight: "bold",
          color: "#5b0101",
          marginBottom: "20px",
        }}
      >
        📅 Day-wise Orders
      </h1>

      {Object.keys(grouped).length === 0 && (
        <p style={{ fontSize: "18px" }}>No orders yet.</p>
      )}

      {Object.entries(grouped).map(([date, list]) => (
        <div
          key={date}
          style={{
            marginBottom: "25px",
            border: "1px solid #f3d6d0",
            borderRadius: "12px",
            background: "#fff7f3",
          }}
        >
          {/* Day Header */}
          <div
            style={{
              background: "#5b0101",
              color: "#f6d49c",
              padding: "12px 14px",
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              fontWeight: "bold",
              fontSize: "18px",
            }}
          >
            {date} — {list.length} Order{list.length > 1 ? "s" : ""}
          </div>

          {/* ORDERS */}
          <div style={{ padding: "16px" }}>
            {list.map((order) => (
              <div
                key={order._id}
                style={{
                  display: "flex",
                  gap: "14px",
                  padding: "14px",
                  marginBottom: "14px",
                  background: "#ffffff",
                  borderRadius: "10px",
                  boxShadow: "0 1px 5px rgba(0,0,0,0.08)",
                }}
              >
                {/* FIXED IMAGE LOGIC */}
                <img
                  src={
                    order.selectedImage?.startsWith("http")
                      ? order.selectedImage
                      : `${API_BASE_URL}/${order.selectedImage}`
                  }
                  alt={order.productName}
                  style={{
                    width: 85,
                    height: 85,
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #eee",
                  }}
                />

                {/* Details */}
                <div style={{ flex: 1 }}>
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: "bold",
                      marginBottom: "4px",
                    }}
                  >
                    {order.productName}
                  </div>

                  <div style={{ fontSize: "15px", color: "#444" }}>
                    Amount: <strong>₹{order.amount}</strong>
                  </div>

                  <div style={{ marginTop: "4px", fontSize: "14px" }}>
                    Status:{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color:
                          order.paymentStatus === "paid" ? "#007a0c" : "#b30000",
                      }}
                    >
                      {order.paymentStatus?.toUpperCase()}
                    </span>
                  </div>

                  {order.paymentLink && (
                    <a
                      href={order.paymentLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "13px",
                        color: "#007bff",
                        textDecoration: "underline",
                        marginTop: "5px",
                        display: "inline-block",
                      }}
                    >
                      View Payment Link
                    </a>
                  )}
                </div>

                {/* Buyer + Delete */}
                <div style={{ minWidth: "130px", textAlign: "right" }}>
                  <div
                    style={{ fontSize: "14px", fontWeight: "bold", color: "#333" }}
                  >
                    Buyer
                  </div>
                  <div style={{ fontSize: "14px", marginBottom: "10px" }}>
                    {order.buyerMobile}
                  </div>

                  <button
                    onClick={() => handleDelete(order._id)}
                    style={{
                      background: "#b30000",
                      color: "white",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminOrdersPage;
